// extracted by mini-css-extract-plugin
export default {"wrapper":"Badge_wrapper__s4cbu","icon":"Badge_icon__p5cAs"};